import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button } from '@airia/ui';
import { Reply } from 'lucide-react';
import { stripHtml } from '../../lib/stripHtml';
import { formatEmailBody } from '../../lib/formatEmailBody';
const ReplyEmailButton = ({ replyEmailData }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const plainTextBody = stripHtml(replyEmailData.body);
    const shouldShowToggle = plainTextBody.length > 100;
    const handleReplyAll = async () => {
        try {
            if (typeof Office !== 'undefined' &&
                Office.context.mailbox &&
                Office.context.mailbox.item) {
                const item = Office.context.mailbox.item;
                // Use the displayReplyAllForm method to reply-all to the current email
                if (item.displayReplyAllForm) {
                    item.displayReplyAllForm({
                        htmlBody: formatEmailBody(replyEmailData.body),
                    });
                }
                else {
                    console.error('displayReplyAllForm not available');
                }
            }
            else {
                console.error('Office context or mailbox item not available');
            }
        }
        catch (error) {
            console.error('Error creating reply-all email:', error);
        }
    };
    return (_jsxs("div", { className: "my-2 p-3 bg-blue-50 dark:bg-blue-950/30 border border-blue-200 dark:border-blue-800 rounded-lg", children: [_jsxs("div", { className: "flex items-start gap-3", children: [_jsx("div", { className: "p-2 bg-blue-100 dark:bg-blue-900/50 rounded-full", children: _jsx(Reply, { className: "size-4 text-blue-600 dark:text-blue-400" }) }), _jsxs("div", { className: "flex-1 min-w-0", children: [_jsx("div", { className: "text-sm font-medium text-foreground mb-1", children: "Reply All Draft" }), _jsxs("div", { className: "text-xs text-muted-foreground space-y-1", children: [_jsxs("div", { className: isExpanded ? '' : 'max-h-20 overflow-y-auto', children: [_jsx("span", { className: "font-medium", children: "Body:" }), ' ', isExpanded ? plainTextBody : plainTextBody.substring(0, 100), !isExpanded && shouldShowToggle && '...'] }), shouldShowToggle && (_jsx("button", { onClick: () => setIsExpanded(!isExpanded), className: "text-blue-600 dark:text-blue-400 hover:underline text-xs mt-1", children: isExpanded ? 'Show Less' : 'Show More' }))] })] })] }), _jsxs(Button, { onClick: handleReplyAll, size: "sm", className: "w-full mt-3 bg-blue-600 hover:bg-blue-700 dark:bg-blue-600 dark:hover:bg-blue-500", children: [_jsx(Reply, { className: "size-4 mr-2" }), "Reply All"] })] }));
};
export default ReplyEmailButton;
